export type SurveyId = number;
export type SurveyKey = string;

export enum SurveyKeys {
    CAREER_CHANGE = 'career_change',
    TRIAL_LESSON = 'trial_lesson',
    SPECIAL_EVENT = 'special_event',
    GROUP_COACHING = 'group_coaching',
    MOKUMOKU = 'mokumoku',
    ADJOURNMENT = 'adjournment',
    TRIAL_LESSON_RESERVATION_CANCEL = 'trial_lesson_reservation_cancel',
}

export type SurveyQuestionFormat = 'card' | 'one_by_one';
